<template>
  <!-- Shown while a lazily-loaded game chunk is being fetched (§4). -->
  <div class="pg-loading" role="status" aria-live="polite">
    <div class="pg-loading__spinner" aria-hidden="true" />
    <p class="pg-loading__label">Spel laden…</p>
  </div>
</template>

<script setup></script>

<style scoped>
.pg-loading {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--sp-4);
  color: var(--c-on-brand);
}
.pg-loading__spinner {
  width: 44px;
  height: 44px;
  border: 4px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: pg-loading-spin 0.9s linear infinite;
}
.pg-loading__label {
  font-size: var(--fs-md);
  color: var(--c-on-brand-soft);
}
@keyframes pg-loading-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
